/*$(document).ready(function(){
  $('.search-submit-btn').on('click', function(e){
    e.preventDefault();
    $('.search_form').trigger('submit');
  });

  let sale = $('[href="/collections/sale"]');
  if($(window).width() > 798 && $('.custom-menu').hasClass('visible')) {
    $('.custom-menu').fadeOut(1);
    $('.custom-menu').removeClass('visible');
    $('#mobile-menu-hamburger').find('div').removeClass('open');
  }
  if($(window).width() > 798) {
    if(sale.hasClass('sale-on-menu')){
      sale.removeClass("sale-on-menu");
    }
  } else {
    sale.addClass('sale-on-menu');
  }

  $('.custom-menu').on('touch', function(e){
    e.stopPropagation();
  });

  $("body #mobile-menu-hamburger").off('click touchend');
  $("body #mobile-menu-hamburger").on("click touchend", function(e){
    e.stopPropagation();
    e.preventDefault();
    let headerHeight = $('#header').outerHeight();
    $('.custom-menu').css({
      top: `${headerHeight}px`,
      height: `calc(100vh - ${headerHeight}px`
    });
    if ( $(window).width() < 798) {
      if($('.custom-menu').hasClass('visible')) {
        $(this).find('div').removeClass('open');
        $('.custom-menu').fadeOut(300);
        $('.custom-menu').removeClass('visible');
        $('html').removeClass('hidden-class');
      } else {
        $(this).find('div').addClass('open');
        $('.custom-menu').fadeIn(300);
        $('.custom-menu').scrollTop(0);
        $('.custom-menu').addClass('visible');
        $('html').addClass('hidden-class');
      }
    }
  });
});

$(window).resize(function() {
  if($(window).width() > 798 && $('.custom-menu').hasClass('visible')) {
    $('.custom-menu').fadeOut(1);
    $('.custom-menu').removeClass('visible');
    $('#mobile-menu-hamburger').find('div').removeClass('open');
  }
  if($(window).width() > 798 && $('.top_link').hasClass('sale-on-menu')) {
    $('.top_link').removeClass("sale-on-menu");
  }
});*/
$(document).on('click', '.mobile-menu__toggle-button', function(){
  $('.custom-menu').toggleClass('dev_showMobileMenu');
  $('.search_container input').val('');
  $('.announcement-container').toggle();
});

$('.parent-link--true').on('click', function(e){
 e.preventDefault();
 $(this).next('ul').slideToggle();
  $(this).find('.icon-down-arrow').toggleClass('dev_upArrow');
});